import { Stepper, Step } from 'components/ui';
import styled from 'styled-components';
import theme from 'theme';

export const StyledStepper = styled(Stepper)`
  margin-top: ${theme.padding.section};
  margin-bottom: ${theme.padding.section};
  width: 100%;
`;

export const StyledStep = styled(Step)`
  font-size: ${theme.typography.fontSizeSmall}px;
`;
